"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoryPage = void 0;
var _react = require("react");
var _api = require("../../api");
var _BreadcrumbsWithData = require("../../components/BreadCrumbs/BreadcrumbsWithData");
var _Loading = require("../../components/Loading/Loading");
var _SubcategoryItem = require("../../components/SubcategoryItem/SubcategoryItem");
var _models = require("../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CategoryPage = ()=>{
    const { categoryName, data, loading, title } = (0, _api.useCategory)();
    const siteMapItemCollection = (0, _react.useMemo)(()=>[
            {
                path: '/',
                title: _models.TranslationKey.supportCenter,
                to: ()=>'/'
            },
            {
                path: "/".concat(categoryName),
                title,
                to: ()=>"/".concat(categoryName)
            }
        ], [
        categoryName,
        title
    ]);
    if (loading) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Loading.Loading, {});
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BreadcrumbsWithData.BreadcrumbsWithData, {
                siteMapItemCollection: siteMapItemCollection
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
                        children: title
                    }),
                    data === null || data === void 0 ? void 0 : data.subcategories.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_SubcategoryItem.SubcategoryItem, {
                            ...item
                        }, item.title))
                ]
            })
        ]
    });
};
exports.CategoryPage = CategoryPage;
